<template>
  <div>
    <div class="ui checkbox">
      <input type="checkbox" name="termsAccepted" v-on:change="setTermsAccepted">
      <label>By participating in the sale, you agree to its <a class="aragon underline" href="/static/terms.pdf">terms and conditions</a></label>
    </div>
    <div class="ui hidden divider"></div>
  </div>
</template>

<script>
export default {
  name: 'disclaimer',
  methods: {
    setTermsAccepted(e) {
      this.$store.commit('setTermsAccepted', e.target.checked)
    },
  },
}
</script>

<style scoped>
.checkbox label,
.checkbox label:hover,
.checkbox label:active,
.checkbox label:focus {
  color: white !important;
  font-weight: lighter;
}
a {
  color: white !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Disclaimer.vue?a5c6587e